import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import firebase from "firebase/app";
import "firebase/auth";

const logoutUserLogic = createLogic({
	type: ActionTypes.LOGOUT_USER,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.signOut()
			.then(() => {});
		dispatch(ControlPanelActions.displayQuickMessage(action.message, "success", "user-lock"));
		done();
	},
});

export default [logoutUserLogic];
